module.exports = __webpack_public_path__ + "img/battery_max.ebce2188.svg";